import axios from "axios";
export const GenerateUploadURL = {
  data: () => ({
    ImageURL: "",
  }),
  methods: {
    // async GenerateUploadURLMethods(key, file) {
    //   //   const headers = {
    //   //     "Content-Type": "application/json",
    //   //   };
    //   var dataInput = {
    //     key: key,
    //   };
    //   await axios
    //     .post(
    //       "https://e2qpzlrslb.execute-api.us-east-1.amazonaws.com/s3_upload/get_s3_url",
    //       dataInput
    //     )
    //     .then((response) => {
    //       this.loading = false;
    //       if (response.status == 200) {
    //         this.uploadS3Method(key, response.data.message, file);
    //       }
    //     })
    //     .catch((Error) => {
    //       this.loading = false;
    //       console.log("Error", Error);
    //     });
    // },
    async GenerateUploadURLMethods(key, file) {
      try {
        const response = await axios.post(
          "https://e2qpzlrslb.execute-api.us-east-1.amazonaws.com/s3_upload/get_s3_url",
          { key }
        );

        if (response.status === 200) {
          const uploadURL = response.data.message;

          // ⬇️ WAIT FOR UPLOAD
          const imageUrl = await this.uploadS3Method(key, uploadURL, file);

          // ⬅️ RETURN FINAL IMAGE URL
          return imageUrl;
        }
      } catch (error) {
        console.log("Error generating upload URL:", error);
        return null;
      }
    },
    // async uploadS3Method(key, uploadURL, file) {
    //   try {
    //     const config = {
    //       method: "put",
    //       maxBodyLength: Infinity,
    //       url: uploadURL,
    //       headers: {
    //         "Content-Type": file.type,
    //       },
    //       data: file,
    //     };

    //     const result = await axios(config);

    //     if (result.status === 200 && result.statusText === "OK") {
    //       this.getS3FileMethod(key);
    //     }
    //   } catch (error) {
    //     console.log("Error uploading to S3:", error);
    //   }
    // },

    async uploadS3Method(key, uploadURL, file) {
      try {
        const result = await axios.put(uploadURL, file, {
          headers: {
            "Content-Type": file.type,
          },
        });

        if (result.status === 200) {
          // ⬇️ WAIT FOR DOWNLOAD URL
          const imageUrl = await this.getS3FileMethod(key);
          return imageUrl;
        }
      } catch (error) {
        console.log("Error uploading to S3:", error);
        return null;
      }
    },
    // async getS3FileMethod(key) {
    //   try {
    //     let config = {
    //       method: "post",
    //       maxBodyLength: Infinity,

    //       url: "https://e2qpzlrslb.execute-api.us-east-1.amazonaws.com/s3_download/get_s3_file",
    //       data: { key: key },
    //     };
    //     let result = await axios(config);
    //     if (result.data.status === "Success") {
    //       console.log("result", result);
    //       this.ImageURL = result.data.message;
    //       return this.ImageURL;
    //     }
    //   } catch (error) {
    //     console.log("Err", error);
    //   }
    // },

    async getS3FileMethod(key) {
      try {
        const result = await axios.post(
          "https://e2qpzlrslb.execute-api.us-east-1.amazonaws.com/s3_download/get_s3_file",
          { key }
        );

        if (result.data.status === "Success") {
          return result.data.message; // ✅ FINAL URL
        }
      } catch (error) {
        console.log("Error fetching S3 file:", error);
        return null;
      }
    },
  },
};
